module.exports = __webpack_public_path__ + "static/media/In_Depth_Hero_Mobile.a5cf56a3.png";